export default __webpack_public_path__ + "static/media/investment_n.25e398b8.svg";